import React, { useState, useEffect } from "react";

import { useQuery } from 'react-query'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Loader from 'components/general/Loader'
import { useViewport } from 'components/general/useViewPort'
import PageHeader from "components/common/PageHeader";
import Label from "components/general/Label";
import NotAvailable from "components/common/NotAvailable";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import { getResultsRSC } from "data/Querys"
import RecordsPrototype from "components/general/RecordsPrototype";
import ProgressionRule from "components/common/ProgressionRule";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';

// start List
import Results from 'components/sports/clb/events/speed/Results'
import Heats from 'components/sports/clb/events/speed/HeatsSeeding'


const ClbSpeedSeeding = () => {
  const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();

  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    }
  )

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }
  if (!data?.results) { return <NotAvailable /> }

  const filtersQualRule = {
    type: ['QUALIFICATION'],
    code: ['QUAL_RULE']
  };

  const resultStatus = data?.results?.status?.code;
  const isStartList = isStartListStatus(resultStatus);
  const isLive = isLiveStatus(resultStatus);
  const isFinished = isFinishedStatus(resultStatus);

  return (<>
    <PageHeader data={data} />

    {data?.records && <RecordsPrototype records={data.records} forceResultTypeHader={'HeaderPoints'} forceMobileColumns={['Date', 'Location']} />}

    <ProgressionRule key="progress-component" data={data?.config} filter={filtersQualRule} itemData={'value'} />

    {(isStartList || isLive) &&
      <Tabs
        id="mirs-navsport"
        defaultActiveKey={isStartListStatus(resultStatus) ? `1-${mirs_rsc}` : `2-${mirs_rsc}`}
        className="mb-3 mirs-tab-result"
      >
        <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='Heats' />)} >
          <Heats data={data} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
        </Tab>
        <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderResults' />)} >
          <Results data={data} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
        </Tab>
      </Tabs>
    }

    {isFinished &&
      <Results data={data} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
    }

  </>)
}

export default ClbSpeedSeeding;